import useSWR from 'swr';

/**
 * Custom hook to fetch a list of countries associated with a customer.
 *
 * @param allowRequest - Indicates whether the request to fetch countries should be made. If `false`, the request will not be executed.
 * @returns An object containing the list of countries (`data`), loading state (`isLoading`), and any error encountered (`error`).
 */
const useFetchListCountries = () => {
  const { data, isLoading, error } = useSWR(() => '/v2/client/countries', {
    revalidateOnFocus: false,
  });
  return { data: data?.data || [], isLoading, error };
};

export default useFetchListCountries;
